(function () {
  "use strict";

  angular.module("sempraWebapp").service("sessionData", sessionDataService);

  /** @ngInject */
  function sessionDataService() {
    var that = this,
      localStorageAvailable = storageAvailable(),
      data = {};

    this.Keys = {
      USERNAME_KEY: "username",
      PASSWORD_KEY: "password",
      LANGUAGE_KEY: "language",
      ACCESS_TOKEN_KEY: "accessToken",
      REFRESH_TOKEN_KEY: "refreshToken",
      USER_ID: "userId",
      USER_ROLE_KEY: "userRole",
      FIRST_NAME_KEY: "firstName",
      LAST_NAME_KEY: "lastName",
      DEFAULT_FACILITY_ID: "defaultFacilityId",
      COUNTRY_CODE: "countryIsoCode",
      RECEIVE_EMAIL: "receiveEmailNotifications",
      TOPICS_LIST: "topicList",
      SMALL_MENU: "smallMenu",
      CURRENCY: 'currency'
    };

    this.getAll = function () {
      return angular.copy(data);
    };

    this.getValue = function (key) {
      if (data.hasOwnProperty(key) && data[key] !== null) {
        return data[key];
      } else if (localStorageAvailable) {
        var value = localStorage.getItem(key);
        if (value !== null) {
          data[key] = value;
          return value;
        }
      }
      return null;
    };

    this.setValue = function (key, value) {
      data[key] = value;
      if (localStorageAvailable) {
        localStorage.setItem(key, value);
      }
    };

    this.clearAll = function () {
      if (localStorageAvailable) {
        localStorage.removeItem(that.Keys.USERNAME_KEY);
        localStorage.removeItem(that.Keys.PASSWORD_KEY);
        localStorage.removeItem(that.Keys.ACCESS_TOKEN_KEY);
        localStorage.removeItem(that.Keys.REFRESH_TOKEN_KEY);
        localStorage.removeItem(that.Keys.USER_ID);
        localStorage.removeItem(that.Keys.USER_ROLE_KEY);
        localStorage.removeItem(that.Keys.FIRST_NAME_KEY);
        localStorage.removeItem(that.Keys.LAST_NAME_KEY);
        localStorage.removeItem(that.Keys.DEFAULT_FACILITY_ID);
        localStorage.removeItem(that.Keys.RECEIVE_EMAIL);
        localStorage.removeItem(that.Keys.COUNTRY_CODE);
        localStorage.removeItem(that.Keys.TOPICS_LIST);
        localStorage.removeItem(that.Keys.CURRENCY);
      }
      data = {};
    };

    this.getTitle = function () {
      var data = {
        firstName: localStorage.getItem(that.Keys.FIRST_NAME_KEY),
        lastName: localStorage.getItem(that.Keys.LAST_NAME_KEY)
      };
      return data;
    };

    refresh();

    function refresh() {
      data[that.Keys.USERNAME_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.USERNAME_KEY)
        : null;
      data[that.Keys.LANGUAGE_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.LANGUAGE_KEY)
        : null;
      data[that.Keys.PASSWORD_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.PASSWORD_KEY)
        : null;
      data[that.Keys.ACCESS_TOKEN_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.ACCESS_TOKEN_KEY)
        : null;
      data[that.Keys.REFRESH_TOKEN_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.REFRESH_TOKEN_KEY)
        : null;
      data[that.Keys.USER_ID] = localStorageAvailable
        ? localStorage.getItem(that.Keys.USER_ID)
        : null;
      data[that.Keys.USER_ROLE_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.USER_ROLE_KEY)
        : null;
      data[that.Keys.FIRST_NAME_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.FIRST_NAME_KEY)
        : null;
      data[that.Keys.LAST_NAME_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.LAST_NAME_KEY)
        : null;
      data[that.Keys.DEFAULT_FACILITY_ID] = localStorageAvailable
        ? localStorage.getItem(that.Keys.DEFAULT_FACILITY_ID)
        : null;
      data[that.Keys.COUNTRY_CODE] = localStorageAvailable
        ? localStorage.getItem(that.Keys.COUNTRY_CODE)
        : null;
      data[that.Keys.RECEIVE_EMAIL] = localStorage.getItem(
        that.Keys.RECEIVE_EMAIL
      )
        ? localStorage.getItem(that.Keys.RECEIVE_EMAIL)
        : true;
      data[that.Keys.TOPICS_LIST] = localStorageAvailable
        ? localStorage.getItem(that.Keys.TOPICS_LIST)
        : null;
      data[that.Keys.SMALL_MENU] = localStorage.getItem(that.Keys.SMALL_MENU)
        ? localStorage.getItem(that.Keys.SMALL_MENU)
        : true;
    }

    function storageAvailable() {
      try {
        /* eslint-disable */
        var storage = window["localStorage"],
          /* eslint-enable */
          x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
})();
